import { SVGProps } from 'react';

const ThumbScaleSmallKindUpDownReducedTrue = (props: SVGProps<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clipPath="url(#clip0_598_46)">
            <path
                d="M3.33329 9.99999V4.33332M12.6666 5.99999V11.7345M12.6666 5.99999H12.3333M12.6666 5.99999H14.3762C14.9048 5.99999 15.3333 6.41786 15.3333 6.93332V10.2C15.3333 10.7155 14.9048 11.1333 14.3762 11.1333H13.2516C13.0625 11.1333 12.8911 11.2419 12.8143 11.4105L12.6666 11.7345M12.6666 11.7345L11.1303 15.1055C11.0671 15.2441 10.9263 15.3333 10.7708 15.3333C10.1191 15.3333 9.59083 14.8181 9.59083 14.1826V13.2C9.59083 12.9423 9.37658 12.7333 9.11229 12.7333H6.99996M0.666626 5.79999V9.06666C0.666626 9.58212 1.09512 9.99999 1.6237 9.99999H8.04868C8.75726 9.99999 9.35986 9.49584 9.46761 8.81287L9.98296 5.5462C10.1167 4.69814 9.4439 3.93332 8.56403 3.93332H6.88763C6.62334 3.93332 6.40909 3.72439 6.40909 3.46666V1.81738C6.40909 1.18185 5.88079 0.666656 5.22909 0.666656C5.07365 0.666656 4.93279 0.755928 4.86966 0.894447L3.18563 4.58952C3.10882 4.75805 2.93744 4.86666 2.74833 4.86666H1.6237C1.09512 4.86666 0.666626 5.28452 0.666626 5.79999Z"
                stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                strokeWidth={1.33333}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_598_46">
                <rect width={16} height={16} fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export default ThumbScaleSmallKindUpDownReducedTrue;
